export interface Emoji {
    type: string;
    src: string;
}

class Emojis {
    static ONE = '[1]'
    static TWO = '[2]'
    static THREE = '[3]'
    static CLAPPING = '[鼓掌]'
    static VICTORY = '[胜利]'
    static HANDS_UP = '[举手]'
    static THUMBS_UP = '[强]'
    static FOLDED = '[合十]'
    static POWER = '[强壮]'
    static OK = '[ok]'
    static HEART = '[心]'
    static ONE_HUNDRED = '[100]'
    static SMILING = '[微笑]'
    static PROUD = '[得意]'
    static NAUGHTY = '[调皮]'
    static ASTONISHED = '[吃惊]'
    static HALO = '[光环]'
    static CRYING = '[流泪]'
    static THINKING = '[思考]'
    static YAWNING = '[哈欠]'

    static getList(): Array<Emoji> {
        return [
            {type: Emojis.ONE, src: require("../assets/emojis/1.png")},
            {type: Emojis.TWO, src: require("../assets/emojis/2.png")},
            {type: Emojis.THREE, src: require("../assets/emojis/3.png")},
            {type: Emojis.CLAPPING, src: require("../assets/emojis/clapping.png")},
            {type: Emojis.VICTORY, src: require("../assets/emojis/victory.png")},
            {type: Emojis.HANDS_UP, src: require("../assets/emojis/handsup.png")},
            {type: Emojis.THUMBS_UP, src: require("../assets/emojis/thumbs-up.png")},
            {type: Emojis.FOLDED, src: require("../assets/emojis/folded.png")},
            {type: Emojis.POWER, src: require("../assets/emojis/power.png")},
            {type: Emojis.OK, src: require("../assets/emojis/ok.png")},
            {type: Emojis.HEART, src: require("../assets/emojis/heart.png")},
            {type: Emojis.ONE_HUNDRED, src: require("../assets/emojis/100.png")},
            {type: Emojis.SMILING, src: require("../assets/emojis/smiling.png")},
            {type: Emojis.PROUD, src: require("../assets/emojis/proud.png")},
            {type: Emojis.NAUGHTY, src: require("../assets/emojis/naughty.png")},
            {type: Emojis.ASTONISHED, src: require("../assets/emojis/astonished.png")},
            {type: Emojis.HALO, src: require("../assets/emojis/halo.png")},
            {type: Emojis.CRYING, src: require("../assets/emojis/crying.png")},
            {type: Emojis.THINKING, src: require("../assets/emojis/thinking.png")},
            {type: Emojis.YAWNING, src: require("../assets/emojis/yawning.png")},
        ];
    }

    static getEmoji(text: string): Emoji | null {
        const emojis = this.getList();
        for (const emoji of emojis) {
            if (emoji.type === text) {
                return emoji;
            }
        }

        return null;
    }

    static check(msg: string): string {
        const emojis = this.getList()
        for (const emoji of emojis) {
            if (emoji.type === msg) {
                return emoji.src;
            }
        }
        return "";
    }
}

export default Emojis
